import Factura from './Factura';
import Proveedor from './Proveedor';
import moment from 'moment';

export default class RetIva {
    constructor(retiva) {
        if (retiva) {
            this.id = retiva.id || null;
            this.proveedor = retiva.proveedor || retiva.proveedor ? new Proveedor(retiva.proveedor) : null || null;
            this.numero =  retiva.numero || '';
            this.number = retiva.number || '';
            this.fecha =  retiva.date || moment().toDate();
            this.date =  retiva.date || moment().toDate();
            this.facturas = retiva.facturas || 
                retiva.detalle ? retiva.detalle.map((factura) => new Factura(factura)) : null || null;
            this.duplicate = retiva.duplicate || false;
        }
    }

    get date() {
        return moment(this.fecha).format('DD-MM-YYYY');
    }

    set date(val) {
        this.fecha = moment(val).toDate();
    }

    get dateAPI() {
            let day = this.fecha.getUTCDate() < 10 ? '0' + this.fecha.getUTCDate() : this.fecha.getUTCDate(),
                month = (this.fecha.getUTCMonth() + 1) < 10 ? '0' + (this.fecha.getUTCMonth() + 1) : this.fecha.getUTCMonth() + 1,
                year = this.fecha.getUTCFullYear();
                
            return moment(this.fecha).format('YYYY-MM-DD');
    }

    get numeroRet() {
        let ano = this.fecha.getUTCFullYear(),
            mes = this._pad(this.fecha.getUTCMonth() + 1, 2);

            return ano + mes + this._pad(this.numero, 8) + '';
    }

    set numeroRet(val) {
        this.number = val;
    }

    get number() {
        return this.numero;
    }

    set number(val) {
        this.numero = val;
    }

    get primaryText() {
        return this.numeroRet;
    }

    get secondaryText() {
        return this.date + ' | ' + this.proveedor.name;
    }

    get total_retenido() {
        
        let total = 0;
        if(this.facturas.length > 0) 
            this.facturas.map((factura) => {
                let factor = 1;
                if (factura.tipo === '03') factor = -1;
                return total = total+(parseFloat((factura.retencion))*factor);
            });
        return total;
    }

    _pad(num, size) {
        var s = num+"";
        while (s.length < size) s = "0" + s;
        return s;
    }
}


/** WEBPACK FOOTER **
 ** ./app-react/Models/RetIva.js
 **/